import i18next from 'i18next'
import { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import format, { formatCurrency } from './format'
import locale from './locale'

function getLocaleName(code: string) {
	const { metadata } = (i18next.options.resources ?? {})[code].translation as Record<string, Record<string, string>>
	return metadata?.languageName
}

export function useLocalization(): {
	locale: string
	updateLocale: typeof locale.setCurrent
	locales: { code: string; name: string }[]
	t: typeof i18next.t
	f: typeof format
	fc: typeof formatCurrency
} {
	// This makes sure the component using this hook
	// rerenders when the locale changes
	const { t, i18n } = useTranslation()
	const locales = useMemo(
		() => Object.keys(i18n.options.resources ?? {}).map(code => ({ code, name: getLocaleName(code) })),
		[i18n.options.resources]
	)

	// Make sure format function changes with locale
	// so that we trigger memo updates
	// eslint-disable-next-line react-hooks/exhaustive-deps
	const f = useCallback((...args: Parameters<typeof format>) => format(...args), [locale.getCurrent()])
	const fc = useCallback((...args: Parameters<typeof formatCurrency>) => formatCurrency(...args), [])

	return {
		locale: locale.getCurrent(),
		updateLocale: locale.setCurrent,
		locales,
		f: f as typeof format,
		fc,
		/* @ts-expect-error */
		t,
	}
}
